import script from "./dropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./dropzone.vue?vue&type=script&setup=true&lang=js"

import "./dropzone.vue?vue&type=style&index=0&id=13f3943d&lang=scss&scoped=true"

import exportComponent from "/Users/thijsfenne/Ontwikkeling/vastejob.nl/wp-content/themes/designated-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13f3943d"]])

export default __exports__